import React from 'react';
import PropTypes from 'prop-types';
import TextCard from './TextCard';
import { SContainer, SRow, SSection, SCol } from './styles';
import Image from 'components/Image';
import { calcResize } from 'components/Layout/styles';
import DotSVG from 'components/DotSVG';
import Circles from 'images/svg/double-blue-circle.svg';
import GracefulImage from 'components/GracefulImage';

const TextGrid = ({
  data,
  showNumbers,
  image,
  imageData,
  useGracefulImage,
}) => (
  <>
    <DotSVG width="100%" moveToRight={true} indexZ={1} />
    <SSection>
      <SContainer>
        <SRow>
          {data.map((card, key) => (
            <SCol key={key} md="6">
              <TextCard
                title={card.title}
                showNumbers={showNumbers}
                index={key}
                description={card.description}
                align={card.align}
              />
            </SCol>
          ))}
          {image && (
            <GracefulImage
              filename={image}
              styles={{
                width: calcResize(350, 500),
                borderRadius: 5,
                zIndex: 1,
              }}
              className="image"
              imageData={imageData}
              useDeprecatedImage={!useGracefulImage}
            />
          )}
        </SRow>
        <DotSVG width="75%" moveToRight={true} indexZ={0} />
      </SContainer>
      <Circles className="background-circles" />
    </SSection>
  </>
);

TextGrid.propTypes = {
  data: PropTypes.array,
  showNumbers: PropTypes.bool,
  image: PropTypes.string,
  useGracefulImage: PropTypes.bool,
  imageData: PropTypes.object,
};

export default TextGrid;
